// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.byline[data-v-fae5bece] {\n    margin: 10% auto 0 auto;\n    max-width: 300px;\n    text-align: center;\n}\n@media (min-width: 960px) {\n.byline[data-v-fae5bece] {\n        display: none;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
